var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M2.222,6.111V16.667a1.111,1.111,0,0,0,1.111,1.111H13.889a3.889,3.889,0,0,0,3.889-3.889V6.111a3.889,3.889,0,0,0-3.889-3.889H6.111A3.889,3.889,0,0,0,2.222,6.111ZM13.889,0A6.111,6.111,0,0,1,20,6.111v7.778A6.111,6.111,0,0,1,13.889,20H3.333A3.333,3.333,0,0,1,0,16.667V6.111A6.111,6.111,0,0,1,6.111,0ZM8.333,4.444a3.333,3.333,0,0,1,2.9,4.968,3.333,3.333,0,0,1-1.794,6.143H5.556a1.111,1.111,0,0,1-1.111-1.111V6.667A2.222,2.222,0,0,1,6.667,4.444Zm.786,4.119a1.111,1.111,0,0,0-.786-1.9H6.667V8.889H8.333A1.111,1.111,0,0,0,9.119,8.563Zm.325,4.77a1.111,1.111,0,0,0,0-2.222H6.667v2.222Zm5.011,0a1.111,1.111,0,0,1,0,2.222h-.011a1.111,1.111,0,0,1,0-2.222Z",
    fill: "#ad926f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIconActive);
export default __webpack_public_path__ + "static/media/bookingIcon-active.73f3962d6d55fe76065baa38b26b15a2.svg";
export { ForwardRef as ReactComponent };